module.exports = __webpack_public_path__ + "static/img/product_banner_03_zh.1590851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_03_zh.png
// module id = uQVQ
// module chunks = 34